import React from 'react';
import {Form,Input,Button,Checkbox,message,Spin,Switch,Select,Card, Divider,DatePicker,Result} from 'antd';
import axios from 'axios';
import { UserOutlined, LockOutlined, LoadingOutlined, MailOutlined } from '@ant-design/icons';
import * as serverconfig from '../serverconn'
import moment from 'moment';
import ShapeDrawForm from './ShapeDrawForm';
import proj4 from 'proj4';
import L from 'leaflet';

var CryptoJS = require("crypto-js");

message.config({
  top: 200,
  duration: 2,
  maxCount: 3,
  rtl: true,
});

var token= ''
var bizuserid= ''
const dateFormat = 'DD/MM/YYYY';

const FormItem=Form.Item;
const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;
const { Option } = Select;
const { TextArea } = Input;

class  ApplicationForm extends React.Component {

  state = { 
    datarequested:false,
    mineral_licence_categories:[],
    workflows:[],
    selected_workflow:'',
    application_formfields:[],
    submitted_data:[],
    file_attachments:[],
    selected_licence_category:'',
    selected_licence_category_obj:{},

    //shape data
    area:0,
    length:0,
    shape_data:{},
    selectedSrid:'',

    //map boundary
    map_boundary:{},
    datasubmittedsuccessfully:false,


  }



  formRef = React.createRef();

  componentDidMount() {

    if(localStorage.getItem("api_token")){
       token= localStorage.getItem("api_token")
    }else{
       token= ''
    }

    if(localStorage.getItem("bizuserid")){
        bizuserid= CryptoJS.AES.decrypt(localStorage.getItem("bizuserid") , 'my-secret-key@1234').toString(CryptoJS.enc.Utf8)
      }else{
        bizuserid= ''
      }

    axios.defaults.headers={
      "Content-Type":"application/json",
      Authorization:`Token ${token}`
    }

    axios.get(serverconfig.backendserverurl+`/api/mineral_licence_categories/`)
    .then(res => {
        this.setState({
          mineral_licence_categories:res.data
        })
        this.setState({datarequested:false})
    })

  }

    // Helper function to convert WKT to GeoJSON
     parseGeometry = (wkt) => {
      // Remove SRID=XXXX; prefix if present
      const wktWithoutSrid = wkt.replace(/SRID=\d+;/, '');
  
      let coordinates = [];
  
      if (wktWithoutSrid.startsWith('POLYGON')) {
          // Handle POLYGON geometry
          coordinates = wktWithoutSrid
              .replace('POLYGON ((', '')
              .replace('))', '')
              .split(', ')
              .map(pair => pair.split(' ').map(Number)); // Convert to number
  
          return {
              type: 'Polygon',
              coordinates: [coordinates] // GeoJSON expects a nested array for polygons
          };
      } else if (wktWithoutSrid.startsWith('LINESTRING')) {
          // Handle LINESTRING geometry (for polylines)
          coordinates = wktWithoutSrid
              .replace('LINESTRING (', '')
              .replace(')', '')
              .split(', ')
              .map(pair => pair.split(' ').map(Number)); // Convert to number
  
          return {
              type: 'LineString',
              coordinates: coordinates // GeoJSON format for LineString
          };
      }
  
      throw new Error('Unsupported WKT geometry type');
  };
  

    //sample exists
     isitem_added = (item_name, list) => {
        return list.some((item) => item.label === item_name);
     };

     //uploadImages
    uploadImages=(application_id)=>{
          //////////////////////////////
        ///// UPLOAD FILES
        this.state.file_attachments.forEach((item) => {
          const { value: file, label } = item; // Destructure `value` and `label` for clarity
          console.log("File: "+label)
          if (file) {
            const formData = new FormData();
            formData.append("file_name", label);
            formData.append("application", application_id);
            formData.append("file", file, file.name || "");
        
            axios
              .post(`${serverconfig.backendserverurl}/api/application_files/`, formData, {
                headers: { "content-type": "multipart/form-data" },
              })
              .then((res) => {
                console.log(`File uploaded successfully for label: ${label}`);
              })
              .catch((error) => {
                console.error(`Error uploading file for label: ${label}`, error);
              });
          } else {
            console.log(`No file to upload for label: ${label}`);
          }
          
        });   

    } 
    
    //upload shape
    upload_shape=(application_id)=>{

      let form_data = new FormData();
      form_data.append('srid', this.state.selectedSrid);
      form_data.append('geom', JSON.stringify(this.state.shape_data.geometry));
      form_data.append('application_id', application_id);
      form_data.append('area', this.state.area);
      form_data.append('length', this.state.length);

      axios.post(serverconfig.backendserverurl+'/customqueries/create_shapefile_forapplication', form_data, {
          headers: {
              'content-type': 'multipart/form-data'
          }
      })
      .then(res => {
          message.info(res.data.message);
      })
      .catch(error => console.log(error));

    }



    // on form submit heree
    onFinish = values => {
      if (this.state.selected_licence_category_obj.licence_type==="Spartial" && JSON.stringify(this.state.shape_data)==="{}"){
        message.error("Please provide shape")
      }else{
        this.setState({datarequested:true})

      let form_data = new FormData();
      form_data.append('applicant', bizuserid);
      form_data.append('licence_type', this.state.selected_licence_category,);
      form_data.append('workflow', this.state.selected_workflow);
      form_data.append('submitted_data', JSON.stringify(this.state.submitted_data));
      
      //Register the account first
      axios.post(serverconfig.backendserverurl+'/api/applications/',form_data)
      .then(res =>{
        var application_id=res.data.application_id
        console.log("Application ID: "+application_id)

        //upload images
        this.uploadImages(application_id);

        //upload shapes now
        if (this.state.selected_licence_category_obj.licence_type==="Spartial" && JSON.stringify(this.state.map_boundary)!="{}"){
          this.upload_shape(application_id)
        }

        message.success("Successful submission")
        this.setState({datarequested:false})
        this.setState({datasubmittedsuccessfully:true})

      }).catch(error => console.log(error))
      


      }






    };



    getSpartialData=(e,selectedSrid)=>{

      const { layerType, layer } = e;
      let calLength = 0;
      let calArea = 0;

      // Handle polygons for area calculation
        if (layerType === 'polygon') {
          const latlngs = layer.getLatLngs();
          const calculatedArea = L.GeometryUtil.geodesicArea(latlngs[0]); // Area in m²
          const areaInKm2 = (calculatedArea / 1000000).toFixed(2); // Convert m² to km²
          this.setState({area:areaInKm2})
          this.setState({length:0})

          calArea += parseFloat(areaInKm2); // Accumulate total area
      }

      // Handle polylines for length calculation
      if (layerType === 'polyline') {
          const latlngs = layer.getLatLngs();
          const totalLength = L.GeometryUtil.length(latlngs).toFixed(2); // Length in meters

          this.setState({area:0})
          this.setState({length:totalLength})

          calLength += totalLength;
      }

      const geojson = layer.toGeoJSON();

      const geometryType = geojson.geometry.type;
      let transformedCoordinates;

      switch (geometryType) {
          case 'Point':
              transformedCoordinates = proj4(`EPSG:4326`, `EPSG:${selectedSrid}`, geojson.geometry.coordinates);
              break;
          case 'LineString':
          case 'MultiPoint':
              transformedCoordinates = geojson.geometry.coordinates.map(coord =>
                  proj4(`EPSG:4326`, `EPSG:${selectedSrid}`, coord)
              );
              break;
          case 'Polygon':
          case 'MultiLineString':
              transformedCoordinates = geojson.geometry.coordinates.map(ring =>
                  ring.map(coord => proj4(`EPSG:4326`, `EPSG:${selectedSrid}`, coord))
              );
              break;
          case 'MultiPolygon': // Handle multi-part polygons
              transformedCoordinates = geojson.geometry.coordinates.map(polygon =>
                  polygon.map(ring =>
                      ring.map(coord => proj4(`EPSG:4326`, `EPSG:${selectedSrid}`, coord))
                  )
              );
              break;
          default:
              alert('Unsupported geometry type');
              return;
      }

      // Construct the transformed GeoJSON
      const transformedGeom = {
          ...geojson,
          geometry: {
              ...geojson.geometry,
              coordinates: transformedCoordinates
          }
      };
 
      console.log("transformedGeom: "+JSON.stringify(transformedGeom))
      this.setState({shape_data:transformedGeom})
      this.setState({selectedSrid:selectedSrid})

     
    }


  render(){

    if(this.state.datarequested===true){
      return(
        <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
            <Spin  size="large">
              <div className="content" />
            </Spin>  
        </div>
      )

    }else{


      if(this.state.datasubmittedsuccessfully===true){
        return(
          <div>
              <Card>
                <Result
                status="success"
                title="Successfully Application "
                extra={[
                  <Button  type='primary' onClick={()=>{window.location.reload(false)}}>Finish</Button>,
                ]}
                />
              </Card>
          </div>
        )

      }else{
        return (

          <div>
           <Divider></Divider>
        
          <Form
            name="register"
            onFinish={this.onFinish}
          >
  
          <FormItem label="Licence Category">
              <Select 
              placeholder="Select Licence Category" 
              style={{  }} 
              value={this.state.selected_licence_category}
              onChange={(val)=>{
                this.setState({workflows:[]})
                this.setState({application_formfields:[]})
                this.setState({selected_licence_category:val})

                //get associated workflow
                let form_data = new FormData();
                form_data.append('licence_category_id', val);
                axios.post(serverconfig.backendserverurl+'/customqueries/get_licence_workflows', form_data, {
                headers: {
                    'content-type': 'multipart/form-data'
                }
                })
                .then(res => {
                    this.setState({workflows:res.data.report})

                    //set category
                    this.setState({selected_licence_category_obj:res.data.licence_category})
                })
                .catch(error => console.log(error))





                ////////////////////////////////////////////
               ///////////////////////////////////////////////
                //get jurisdiction boundary
                //////////////////////////////
                /////////////////////////////////
                axios.get(`${serverconfig.backendserverurl}/api/mineral_licence_categories/${val}`)
                .then(res => {  

                      //get juridetails
                      axios.get(serverconfig.backendserverurl+`/customqueries/get_jurisdiction_boundary/${res.data.jurisdiction}/`)
                      .then(response => {
          
                          //setShapes(response.data);
                          //console.log('API Response:', JSON.stringify(response.data.data)); // Debugging
                          // Ensure data is an array; if it's a FeatureCollection, extract the features array
                          const features = response.data.data.features.map(feature => ({
                              ...feature,
                              geometry:this.parseGeometry(feature.geometry) // Convert WKT to GeoJSON
                          }));

                          //set jurisdiction
                          this.setState({map_boundary:features[0]})
                          console.log("Jury obj "+JSON.stringify(features[0]))

                      })
                      .catch(error => {
                          console.error('Error fetching shapes', error);
                      });


                    })
                   //end of jury search

              }} 

              showSearch
              optionFilterProp="children"
              onFocus={this.onFocus}
              onBlur={this.onBlur}
              onSearch={this.onSearch}
                                  
              >
                {this.state.mineral_licence_categories.map(
                  (licence)=>(
                    <Option value={licence.id}>{licence.licence}</Option>
                  ))}
              </Select>
          </FormItem>


          <FormItem label="Service">
              <Select 
              placeholder="Select Service" 
              style={{  }} 
              value={this.state.selected_workflow}
              onChange={(val)=>{

                this.setState({application_formfields:[]})
                this.setState({selected_workflow:val})

                axios.get(serverconfig.backendserverurl+`/api/application_formfields/?workflow=${val}&is_required=${true}`)
                .then(res => {
                    this.setState({
                        application_formfields:res.data
                    })
                })

              }} 
              showSearch
              optionFilterProp="children"
              onFocus={this.onFocus}
              onBlur={this.onBlur}
              onSearch={this.onSearch}                
              >
                {this.state.workflows.map(
                  (wfl)=>(
                    <Option value={wfl.id}>{wfl.name}</Option>
                  ))}
              </Select>
          </FormItem>


          {
            this.state.application_formfields.length>0?
            <div>
                {
                 this.state.application_formfields.map((field)=>{
                    var label=field.label
                    var field_type=field.field_type
                    var is_required=field.is_required
                    var options=JSON.parse(field.options)  

                    //map value now
                    if (field_type==="text"){

                        return (

                        <FormItem label={label}
                        name={label}

                            rules={[
                                {
                                    required:is_required===true?true:false,
                                    message: 'Please select',
                                },
                                ]}
                            >
                                <Input 
                                placeholder={label} 
                                onChange={(val)=>{
                                    //add to data list now
                                    var dataobj={
                                        'key':this.state.submitted_data.length+1,
                                        'value':val.target.value,
                                        'label':label,
                                        'field_type':field_type

                                    }

                                    //check item existence in data
                                    if (this.isitem_added(label,this.state.submitted_data)){
                                        const elementsIndex = this.state.submitted_data.findIndex(element => element.label == label )
                                        let newArray = [...this.state.submitted_data]
                                        newArray[elementsIndex] = {...newArray[elementsIndex], 
                                            "value":val.target.value,
                                        }
                                        this.setState({
                                            submitted_data: newArray,
                                        });

                                    }else{
                                        var new_array = [
                                        ...this.state.submitted_data,
                                        dataobj,
                                        ];
                                        this.setState({ submitted_data: new_array });
                                    }

                                }}
                                />
    
                            </FormItem>
                        )

                    }

                    if (field_type==="textarea"){
                        var value=''

                        return (

                        <FormItem label={label}
                            name={label}
                            rules={[
                                {
                                    required:is_required===true?true:false,
                                    message: 'Please select',
                                },
                                ]}
                            >
                                <TextArea
                                    placeholder={label} 
                                    autoSize={{ minRows: 2, maxRows: 6 }}
                                    onChange={(val)=>{
                                        value=val.target.value
                                        //add to data list now
                                        var dataobj={
                                            'key':this.state.submitted_data.length+1,
                                            'value':val.target.value,
                                            'label':label,
                                            'field_type':field_type
                                        }

                                    //check item existence in data
                                    if (this.isitem_added(label,this.state.submitted_data)){
                                        const elementsIndex = this.state.submitted_data.findIndex(element => element.label == label )
                                        let newArray = [...this.state.submitted_data]
                                        newArray[elementsIndex] = {...newArray[elementsIndex], 
                                            "value":val.target.value,
                                        }
                                        this.setState({
                                            submitted_data: newArray,
                                        });

                                    }else{
                                        var new_array = [
                                        ...this.state.submitted_data,
                                        dataobj,
                                        ];
                                        this.setState({ submitted_data: new_array });
                                    }
                                    
                                    }}
                                />
                            </FormItem>
                        )

                    }


                    if (field_type==="number"){
                      return (

                        <FormItem label={label}
                        name={label}

                            rules={[
                                {
                                    required:is_required===true?true:false,
                                    message: 'Cant be empty',
                                },
                                ]}
                            >
                                <Input 
                                placeholder={label} 
                                type='number'
                                onChange={(val)=>{
                                    //add to data list now
                                    var dataobj={
                                        'key':this.state.submitted_data.length+1,
                                        'value':val.target.value,
                                        'label':label,
                                        'field_type':field_type
                                    }

                                    //check item existence in data
                                    if (this.isitem_added(label,this.state.submitted_data)){
                                        const elementsIndex = this.state.submitted_data.findIndex(element => element.label == label )
                                        let newArray = [...this.state.submitted_data]
                                        newArray[elementsIndex] = {...newArray[elementsIndex], 
                                            "value":val.target.value,
                                        }
                                        this.setState({
                                            submitted_data: newArray,
                                        });

                                    }else{
                                        var new_array = [
                                        ...this.state.submitted_data,
                                        dataobj,
                                        ];
                                        this.setState({ submitted_data: new_array });
                                    }

                                }}
                                />
    
                            </FormItem>
                        )


                    }

                    if (field_type==="date"){
                      return (

                        <FormItem label={label}
                            name={label}
                            rules={[
                                {
                                    required:is_required===true?true:false,
                                    message: 'Cant be empty',
                                },
                                ]}
                            >

                            <DatePicker 
                            onChange={(date, dateString)=>{
                              
                              this.setState({ expiry_date: dateString})
                            
                              //add to data list now
                              var dataobj={
                                'key':this.state.submitted_data.length+1,
                                'value':dateString,
                                'label':label,
                                'field_type':field_type

                            }

                            //check item existence in data
                            if (this.isitem_added(label,this.state.submitted_data)){
                                const elementsIndex = this.state.submitted_data.findIndex(element => element.label == label )
                                let newArray = [...this.state.submitted_data]
                                newArray[elementsIndex] = {...newArray[elementsIndex], 
                                    "value":dateString,
                                }
                                this.setState({
                                    submitted_data: newArray,
                                });

                            }else{
                                var new_array = [
                                ...this.state.submitted_data,
                                dataobj,
                                ];
                                this.setState({ submitted_data: new_array });
                            }
                            
                            
                            }}
                            format={dateFormat} 
                            
                            />

                            </FormItem>
                        )


                    }


                    if (field_type==="file"){

                      return (
                    <Form.Item label={label}>
                          <Input
                            type="file"
                            accept=".pdf"
                            placeholder="PDF"
                            onChange={(e) => {
                              const file = e.target.files[0]; // Retrieve the selected file
                              const dataobj = {
                                key: this.state.file_attachments.length + 1,
                                value: file,
                                label: label,
                              };

                              // Check if item already exists in file_attachments
                              const existingIndex = this.state.file_attachments.findIndex(
                                (element) => element.label === label
                              );

                              if (existingIndex !== -1) {
                                // Update the existing item
                                const updatedAttachments = [...this.state.file_attachments];
                                updatedAttachments[existingIndex] = { ...updatedAttachments[existingIndex], value: file };
                                this.setState({ file_attachments: updatedAttachments });
                              } else {
                                // Add new item
                                this.setState((prevState) => ({
                                  file_attachments: [...prevState.file_attachments, dataobj],
                                }));
                              }
                            }}
                          />
                        </Form.Item> 

                      )

                    }


                    if (field_type==="select"){

                        return (

                        <FormItem label={label}
                            name={label}
                            rules={[
                                {
                                    required:is_required===true?true:false,
                                    message: 'Please select',
                                },
                                ]}
                            >
                            <Select 
                            placeholder={label}
                            style={{  }} 
                            onChange={(val)=>{
                                value=val
                                //add to data list now
                                var dataobj={
                                    'key':this.state.submitted_data.length+1,
                                    'value':val,
                                    'label':label,
                                    'field_type':field_type

                                }
                                
                            //check item existence in data
                            if (this.isitem_added(label,this.state.submitted_data)){
                                const elementsIndex = this.state.submitted_data.findIndex(element => element.label == label )
                                let newArray = [...this.state.submitted_data]
                                newArray[elementsIndex] = {...newArray[elementsIndex], 
                                    "value":val,
                                }
                                this.setState({
                                    submitted_data: newArray,
                                });

                            }else{
                                var new_array = [
                                ...this.state.submitted_data,
                                dataobj,
                                ];
                                this.setState({ submitted_data: new_array });
                            }


                            }} 
                            showSearch
                            optionFilterProp="children"
                            onFocus={this.onFocus}
                            onBlur={this.onBlur}
                            onSearch={this.onSearch}   
                            >
                            {
                                options.map((itm)=>{
                                    return(
                                        <Option value={itm.value}>{itm.label}</Option>

                                    )
                                })
                            }
                            </Select>
                            </FormItem>
                        )

                    }

                    if (field_type==="checkbox"){

                      return (
                        <Form.Item label={label} >
                          <Switch
                              onChange={val=>{
                              
                                    //add to data list now
                                    var dataobj={
                                      'key':this.state.submitted_data.length+1,
                                      'value':val,
                                      'label':label,
                                      'field_type':field_type
                                  }

                                  //check item existence in data
                                  if (this.isitem_added(label,this.state.submitted_data)){
                                      const elementsIndex = this.state.submitted_data.findIndex(element => element.label == label )
                                      let newArray = [...this.state.submitted_data]
                                      newArray[elementsIndex] = {...newArray[elementsIndex], 
                                          "value":val,
                                      }
                                      this.setState({
                                          submitted_data: newArray,
                                      });

                                  }else{
                                      var new_array = [
                                      ...this.state.submitted_data,
                                      dataobj,
                                      ];
                                      this.setState({ submitted_data: new_array });
                                  }

                              
                              }}
                              checkedChildren="Yes"
                              unCheckedChildren="No"
                              />
                        </Form.Item>
                      )
                    }
                })}

            </div>
            :
            null
          }


          {
            this.state.selected_licence_category_obj.licence_type==="Spartial" && JSON.stringify(this.state.map_boundary)!="{}"?
            <div style={{margin:8}}>
            <h4>Map Shape</h4>
            <ShapeDrawForm selected_licence_category={this.state.selected_licence_category}  getSpartialData={this.getSpartialData} map_boundary={this.state.map_boundary}  />
            </div>
            :
            null
          }


        <Form.Item>
            <Button type="primary" htmlType="submit">
            Submit Application
            </Button>
        </Form.Item>
        
        </Form>

        </div>
    );


    }

    }

  }

}


export default ApplicationForm;


